function getAccesorNameOrIdName(columns, colIndex) {
  const AccesorName = columns[colIndex.toString()].accessor;

  if (typeof AccesorName === 'function') {
    const idName = columns[colIndex.toString()].id;
    return idName;
  }

  return AccesorName;
}

function getAccesorName(columns, colIndex) {
  const AccesorName = columns[colIndex.toString()].accessor;

  return AccesorName;
}

function getAccesorValue(currentRecords, index, columns, colIndex) {
  const AccesorValue = currentRecords[index][getAccesorName(columns, colIndex)];
  return AccesorValue;
}

function getAccesorValueSpecial(currentRecords, index, columns, colIndex) {
  const AccesorValue =
    currentRecords[index][getAccesorNameOrIdName(columns, colIndex)];
  return AccesorValue;
}

function getHeader(columns, colIndex) {
  return columns[colIndex].Header;
}

export function reactTableToDataDownload(reactTable, columns) {
  const currentRecords = reactTable.getResolvedState().sortedData;
  const data_to_download = [];
  for (let index = 0; index < currentRecords.length; index++) {
    const record_to_download = {};

    for (let colIndex = 0; colIndex < columns.length; colIndex++) {
      record_to_download[getHeader(columns, colIndex)] = getAccesorValue(
        currentRecords,
        index,
        columns,
        colIndex
      );
    }
    data_to_download.push(record_to_download);
  }
  return data_to_download;
}

export function reactDrivingTableToDataDownload(reactTable, columns) {
  const currentRecords = reactTable.getResolvedState().sortedData;
  const data_to_download = [];
  for (let index = 0; index < currentRecords.length; index++) {
    const record_to_download = {};

    for (let colIndex = 0; colIndex < columns.length; colIndex++) {
      record_to_download[getHeader(columns, colIndex)] = getAccesorValueSpecial(
        currentRecords,
        index,
        columns,
        colIndex
      );
    }
    data_to_download.push(record_to_download);
  }
  return data_to_download;
}
